import ConstUtils from '@/utils/ConstUtils.js';

export default class GpsDeviceEvents {

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }

  contains(name) {
    if (name) {
      //
    }
    return false;
  }

  findByName(name, data) {
    this.domain.logger().info(name, data);
    return null;
  }

  save(device) {
    var company = this.domain.session().company();
    if (device.hasCompany()) {
      company = device.company();
    }
    var event = GpsDeviceEvents.Save.Request(company, device);
    return this.eventsDomain.initRequest(event);
  }

  list(filter, includePositions) {
    var event = GpsDeviceEvents.List.Request(filter, includePositions);
    return this.eventsDomain.initRequest(event);
  }

  restore(deviceId) {
    var event = GpsDeviceEvents.Restore.Request(deviceId);
    return this.eventsDomain.initRequest(event);
  }

  remove(device) {
    var event = GpsDeviceEvents.Remove.Request(device);
    return this.eventsDomain.initRequest(event);
  }

  static Save = {
    Names: {
      Request: 'GpsDeviceSaveRequestEvent',
      Response: 'GpsDeviceSaveResponseEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'The specified GPS device does not exist',
        details: '',
      },
    },

    Request: function (company, device) {
      var data = "";
      if (device.id) {
        data = device.data;
      } else {
        data = device;
      }
      var companyId;
      if (company.id) {
        companyId = company.id();
      } else {
        companyId = company[ConstUtils.FIELDS.ID];
      }
      data['Company'] = companyId;
      var cmd = {
        GpsDevice: data,
        handler: 'GpsDeviceSaveRequestEvent',
        eventName: 'GpsDeviceSaveRequestEvent',
      }
      return cmd
    },
  }

  static List = {
    Names: {
      Request: 'GpsDeviceListRequestEvent',
      Response: 'GpsDeviceListResponseEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: '',
      },
    },

    Request: function (filter, includePositions = false) {
      var event = {
        handler: "GpsDeviceListRequestEvent",
        eventName: "GpsDeviceListRequestEvent",
        filter: filter.data,
        includePositions: includePositions,
      };
      return event;
    },
  }

  static Remove = {
    Names: {
      Request: 'GpsDeviceRemoveRequestEvent',
      Response: 'GpsDeviceRemoveResponseEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'The specified GPS device does not exist',
        details: '',
      },
    },

    Request: function (device) {
      var data = "";
      if (device.id) {
        data = device.id();
      } else {
        data = device[ConstUtils.FIELDS.ID];
      }
      var cmd = {
        GpsDevice: data,
        handler: 'GpsDeviceRemoveRequestEvent',
        eventName: 'GpsDeviceRemoveRequestEvent',
      }
      return cmd
    },
  }

  static Restore = {
    Names: {
      Request: 'GpsDeviceRestoreRequestEvent',
      Response: 'GpsDeviceRestoreResponseEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'The specified GPS device does not exist',
        details: '',
      },
    },

    Request: function (deviceId) {
      var cmd = {
        GpsDevice: deviceId,
        handler: GpsDeviceEvents.Restore.Names.Request,
        eventName: GpsDeviceEvents.Restore.Names.Request,
      }
      return cmd
    },
  }

  route(params) {
    var event = GpsDeviceEvents.Route.Request(params);
    return this.eventsDomain.initRequest(event);
  }

  static Route = {
    Names: {
      Operation: 'GpsDeviceRouteQueryOperation',
      Notification: 'GpsDeviceRouteQueryNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: '',
      },
    },

    Request: function (params) {
      var event = {
        handler: this.Names.Operation,
        eventName: this.Names.Operation,
        Params: params.data,
      };
      return event;
    },
  }

  routePlayback(params) {
    var event = GpsDeviceEvents.RoutePlayback.Request(params);
    return this.eventsDomain.initRequest(event);
  }

  /**
   * A few sentences about a zoomed-in stretch of a route, worded by ServiceLlm from the Map
   * page's What happened events. params.data: deviceId, from, to (epoch ms), language, zone,
   * intervalS, and events as a JSON string.
   */
  routeSummary(params) {
    var event = GpsDeviceEvents.RouteSummary.Request(params);
    return this.eventsDomain.initRequest(event);
  }

  static RouteSummary = {
    Names: {
      Operation: 'RouteSummaryQueryOperation',
      Notification: 'RouteSummaryNotification',
    },

    Request: function (params) {
      return {
        handler: this.Names.Operation,
        eventName: this.Names.Operation,
        Params: params.data,
      };
    },
  }

  static RoutePlayback = {
    Names: {
      Operation: 'GpsDeviceRoutePlaybackQueryOperation',
      Notification: 'GpsDeviceRoutePlaybackQueryNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: '',
      },
    },

    Request: function (params) {
      var event = {
        handler: this.Names.Operation,
        eventName: this.Names.Operation,
        Params: params.data,
      };
      return event;
    },
  }
}
